import trackingApiClient from './trackingApiClient';
import type { ReportParams, ReportResponse } from '../types/report';

const ENDPOINT = '/reports';

export const reportService = {
  async getReport(params: ReportParams): Promise<ReportResponse> {
    const { data } = await trackingApiClient.get<ReportResponse>(ENDPOINT, { params });
    return data;
  },
};
